import { UserMenu } from './UserMenu.js';

/**
 * Sidebar footer: the account cluster, shared by the desktop aside and the mobile drawer (108)
 * so the two never drift apart. The theme control (115) now lives inside `UserMenu`'s own
 * popover, alongside View profile and Sign out, rather than in a separately-boxed row here.
 */
export function SidebarFooter() {
  return <UserMenu />;
}
